import Svg, { Path } from "react-native-svg";
const ChevronUp = () => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none">
    <Path
      d="M9.96004 7.52539L6.70004 4.26539C6.31504 3.88039 5.68504 3.88039 5.30004 4.26539L2.04004 7.52539" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"
    />
  </Svg>
);
export default ChevronUp;
